
import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#F48FB1] to-[#EC407A]">
      <div className="max-w-4xl mx-auto text-center">
        <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6">
          お子様の健康について<br className="sm:hidden" />
          お気軽にご相談ください
        </h3>
        <p className="text-base sm:text-lg md:text-xl text-white/90 mb-8 sm:mb-12 leading-relaxed px-4">
          岡山市北区で25年の実績<br className="sm:hidden" />
          地域の皆様に信頼される小児科クリニック
        </p>
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center px-4">
          <Link
            to="/contact"
            className="w-full sm:w-auto bg-white hover:bg-gray-50 text-[#F48FB1] px-8 sm:px-12 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            診療予約・お問い合わせ
          </Link>
          <a
            href="tel:0860123456"
            className="w-full sm:w-auto bg-[#D81B60] hover:bg-[#C2185B] text-white px-8 sm:px-12 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold transition-all shadow-lg hover:shadow-xl whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line text-xl sm:text-2xl"></i>
            086-012-3456
          </a>
        </div>
      </div>
    </section>
  );
}
